import { toastError } from '../utils/toast';

export const initializeGoogleOAuth = () => {
  const config: GoogleOAuthConfig = {
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    scope: 'openid email profile',
    response_type: 'code',
    redirect_uri: `${window.location.origin}/auth/google/callback`,
    access_type: 'offline',
    // Do not set prompt: 'consent' — it forces the consent screen on every login.
    // Omitting prompt lets Google skip consent for returning users with an active session.
    // First-time users still see consent; subsequent logins are seamless.
  };

  const authUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
  const searchParams = new URLSearchParams(config as unknown as Record<string, string>);
  const finalUrl = `${authUrl}?${searchParams.toString()}`;

  // Alert to facilitate copying the redirect URI

  return finalUrl;
};
